import { useEffect, useRef, useState } from 'react';
import {
  DEMAND_LIST_COLUMNS,
  defaultVisibleColumnIds,
  loadVisibleColumnIds,
  saveVisibleColumnIds,
} from '../lib/demandListColumns.js';

export function useDemandListColumns() {
  const [visibleIds, setVisibleIds] = useState(() => loadVisibleColumnIds());

  function toggleColumn(id) {
    const col = DEMAND_LIST_COLUMNS.find((c) => c.id === id);
    if (!col || col.required) return;
    setVisibleIds((prev) => {
      const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      return saveVisibleColumnIds(next);
    });
  }

  function resetColumns() {
    setVisibleIds(saveVisibleColumnIds(defaultVisibleColumnIds()));
  }

  return { visibleIds, toggleColumn, resetColumns };
}

export default function DemandColumnsPicker({ visibleIds, onToggle, onReset }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    function onDocClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    function onKey(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="list-toolbar-menu" ref={menuRef}>
      <button
        type="button"
        className="btn-ghost list-columns-btn"
        aria-expanded={open}
        aria-haspopup="dialog"
        onClick={() => setOpen((value) => !value)}
      >
        Filter
      </button>
      {open ? (
        <div className="list-columns-menu" role="dialog" aria-label="Filter by column">
          <div className="list-columns-menu-head">
            <strong>Filter by column</strong>
            <button type="button" className="text-link strong" onClick={onReset}>
              Reset
            </button>
          </div>
          <ul className="list-columns-options">
            {DEMAND_LIST_COLUMNS.map((col) => {
              const checked = visibleIds.includes(col.id);
              return (
                <li key={col.id}>
                  <label className="list-columns-option">
                    <input
                      type="checkbox"
                      checked={checked}
                      disabled={Boolean(col.required)}
                      onChange={() => onToggle(col.id)}
                    />
                    <span>
                      {col.label}
                      {col.required ? ' (required)' : ''}
                    </span>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
